<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">Dedication</span></p>
<p class="p2"> </p>
<p class="p2"> </p>
<p class="p2"> </p>
<p class="p2">To Jennifer and Kira, who guided me through when the words wouldn’t come and forgave me for my kinks.</p>
<p class="p2"> </p>
<p class="p2">And to John, who unknowingly supplied the soundtrack.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?1954d0c8